import React from 'react';
import { Input, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DSBox from '../../../design-system/DSBox';
import DSPaper from '../../../design-system/Paper/DSPaper';
import DSValueTypography from '../../../design-system/Typography/DSValueTypography';
import DSVideoIcon from '../../../design-system/DSVideoIcon';
import useInputsDragAndDrop from '../hooks/useInputsDragAndDrop';
import { FILE_VALIDATION } from '../../../consts/dragAndDropInputs';

type KlydoFileInputEmptyProps = {
  onFileChange: (file: File) => void;
};

const KlydoFileInputEmpty = ({ onFileChange }: KlydoFileInputEmptyProps) => {
  const { spacing, palette } = useTheme();

  const { isDragging, dragHandlers, handleInputChange } = useInputsDragAndDrop({
    onFileAccepted: onFileChange,
    validation: FILE_VALIDATION.video,
  });

  return (
    <DSBox
      component="label"
      sx={{ width: '100%', cursor: 'pointer' }}
      {...dragHandlers}
    >
      <DSPaper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: spacing(15),
          padding: spacing(2, 4),
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'stretch',
          borderRadius: spacing(3),
          border: `2px dashed ${isDragging ? palette.primary.main : palette.white[12]}`,
          background: isDragging ? palette.white[5] : 'transparent',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: palette.white[5],
            borderColor: palette.white[20],
            '& .add-icon': {
              color: palette.white[90],
            },
          },
        }}
      >
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <DSBox
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: spacing(0.5),
            }}
          >
            <DSBox
              sx={{ display: 'flex', alignItems: 'center', gap: spacing(1) }}
            >
              <DSVideoIcon
                sx={{ color: palette.text.secondary, fontSize: 18 }}
              />
              <DSValueTypography color={palette.gray[119]}>
                MP4, GIF max size 60 MB
              </DSValueTypography>
            </DSBox>
          </DSBox>
          <AddIcon
            className="add-icon"
            sx={{
              color: isDragging ? palette.white[90] : palette.white[70],
              fontSize: 24,
              transition: 'color 0.2s ease',
            }}
          />
        </DSBox>
        <Input
          inputProps={{
            accept: FILE_VALIDATION.video.acceptedExtensions.join(', '),
          }}
          type="file"
          onChange={handleInputChange}
          sx={{ display: 'none' }}
        />
      </DSPaper>
    </DSBox>
  );
};

export default KlydoFileInputEmpty;
